import React, { useEffect } from 'react';
import { ModalProps } from 'antd/lib/modal/Modal';
import { track } from '../../../analytics';
import { usePreviousDistinct } from 'react-use';
import FullScreenModal from '../../vendorlink-views/components/FullScreenModal';

type TrackingModalProps = ModalProps & {
  name: string;
  properties: () => Object;
};

const TrackingFullScreenModal: React.FC<TrackingModalProps> = (props) => {
  const { visible, name, properties } = props;
  const previousVisible = usePreviousDistinct(visible);
  useEffect(() => {
    if (previousVisible !== undefined && previousVisible !== visible) {
      if (visible) {
        track(`${name}/MODAL_SHOW`, properties());
      } else {
        track(`${name}/MODAL_HIDE`, properties());
      }
    }
  }, [name, previousVisible, properties, visible]);
  return <FullScreenModal {...props} />;
};

export default TrackingFullScreenModal;
